import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";

if (localStorage.getItem("trademind_theme") === "light") {
  document.documentElement.classList.add("light");
}
import { AuthProvider } from "@/auth/AuthContext";
import AuthCallback from "@/auth/AuthCallback";
import { I18nProvider } from "@/i18n/I18nContext";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import { LoginPage, RegisterPage, ForgotPasswordPage, ResetPasswordPage } from "@/pages/Auth";
import AppLayout from "@/pages/AppLayout";
import Dashboard from "@/pages/Dashboard";
import Analyze from "@/pages/Analyze";
import Journal from "@/pages/Journal";
import PropFirm from "@/pages/PropFirm";
import Mentor from "@/pages/Mentor";
import Scanner from "@/pages/Scanner";
import Calendar from "@/pages/Calendar";
import CalculatorPage from "@/pages/Calculator";
import Settings from "@/pages/Settings";
import Upgrade from "@/pages/Upgrade";
import BillingSuccess from "@/pages/BillingSuccess";
import Admin from "@/pages/Admin";
import { Privacy, Terms } from "@/pages/Legal";
import Blog from "@/pages/Blog";

function ReferralRedirect() {
  const { code } = useParams();
  useEffect(() => {
    if (code) localStorage.setItem("tm_ref_code", code.toUpperCase());
  }, [code]);
  return <Navigate to="/register" replace />;
}

function AppRouter() {
  const location = useLocation();
  // Google OAuth callback: session_id in URL fragment must be processed before any route/auth guard
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/ref/:code" element={<ReferralRedirect />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<Blog />} />
      <Route path="/billing/success" element={<BillingSuccess />} />
      <Route path="/app" element={<AppLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="analyze" element={<Analyze />} />
        <Route path="journal" element={<Journal />} />
        <Route path="propfirm" element={<PropFirm />} />
        <Route path="mentor" element={<Mentor />} />
        <Route path="scanner" element={<Scanner />} />
        <Route path="calendar" element={<Calendar />} />
        <Route path="calculator" element={<CalculatorPage />} />
        <Route path="upgrade" element={<Upgrade />} />
        <Route path="admin" element={<Admin />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster theme="dark" position="top-right" richColors />
            <AppRouter />
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
